import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const CardWrapper = styled.div<{
  isFDR: boolean;
  isOnHomePage: boolean;
  width?: string;
}>`
  display: flex;
  flex-direction: column;
  box-shadow: inset 0 0 0 1px var(--fd-colors-border-default);
  border-radius: 4px;
  background-color: var(--fd-colors-background-surface);
  ${({ isOnHomePage }) =>
    isOnHomePage
      ? css`
          width: 96%;
          height: 302px;
          border-radius: 4px;
        `
      : css`
          max-width: 351px;
          width: 96%;
          height: 282px;
        `}

  @media screen and ${breakpoints.desktop.min.sm} {
    width: ${({ width }) => width || "335px"};
  }

  ${({ isFDR }) =>
    isFDR &&
    css`
      flex-shrink: 0;
      scroll-snap-stop: always;
      scroll-snap-align: start;

      @media screen and ${breakpoints.tablet.max.sm} {
        &:only-child {
          width: 100%;
          max-width: 100%;
        }
      }
    `}
`;

export const CardHeader = styled.div<{
  isOnHomePage?: boolean;
  isFDTVPage?: boolean;
}>`
  height: 64px;
  padding: var(--fd-space-space-3);
  display: flex;
  align-items: center;
  background-color: var(--fd-colors-background-layer);
  box-shadow: inset 0 0 0 1px var(--fd-colors-border-default);
  ${({ isOnHomePage, isFDTVPage }) =>
    isOnHomePage || isFDTVPage
      ? css`
          border-radius: 4px 4px 0 0;

          &:hover {
            cursor: pointer;
            background-color: var(--fd-colors-background-hover);
          }
        `
      : css`
          border-radius: 2px;
        `}
`;

export const RaceSummaryInfo = styled.div<{ hidden: boolean }>`
  display: ${({ hidden }) => (hidden ? "none" : "flex")};
  flex-direction: column;
  justify-content: center;

  @media screen and ${breakpoints.tablet.max.sm} {
    display: none;
  }
`;

export const ActionsWrapper = styled.div<{
  isOnHomePage: boolean;
}>`
  width: 100%;
  display: flex;
  margin-top: auto;
  ${({ isOnHomePage }) =>
    !isOnHomePage
      ? css`
          padding: var(--fd-space-space-3);

          & > div {
            flex: 1 0 0;

            &:not(:first-child) {
              margin-left: var(--fd-space-space-3);
            }
          }
        `
      : css`
          justify-content: space-between;
          padding: var(--fd-space-space-3) var(--fd-space-space-3) 0
            var(--fd-space-space-3);
        `}
`;

export const AmountContainer = styled.div`
  display: flex;

  &:not(:last-child) {
    border-right: 1px solid var(--fd-colors-border-subtle);
  }
`;
